<template>

    <div class="vl-region vl-region--alt">
        <div class="vl-layout">
            <div class="vl-grid vl-grid--align-center">
                <div class="vl-col--10-12">
                    <h1 class="vl-title--h1 vl-u-text--bold vl-u-spacer--small vl-u-align-center">
                        In Vlaanderen scoort een<br>
                        gemiddelde woning energielabel D.<br>
                        Scoort u beter?
                    </h1>
                    <p class="vl-u-align-center">
                        Met deze test kunt u het energielabel van uw woning inschatten en
                        vergelijken met andere woningen in Vlaanderen. Ontdek hier ook hoe u uw woning
                        energetisch kan verbeteren tot energielabel A, de Vlaamse doelstelling tegen 2050.
                    </p>
                </div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 924.672 225" class="svg-margin"
                 style="width: 100%; position: relative; height: 232px;">
                <g transform="translate(-50.369 -502)">
                    <g transform="translate(49.609 549.405)">
                        <path d="M127.993,61.652H.4v-.19L12.172,33.931.4,6.4H127.993l11.772,27.531Z"
                              class="cls-1" transform="translate(0.359 5.302)"/>
                        <path d="M196.6,61.652H69.2v-.19L80.972,33.931,69.2,6.4H196.6l11.962,27.531Z"
                              class="cls-2" transform="translate(62.191 5.302)"/>
                        <path d="M334.4,61.652H207v-.19l11.772-27.531L207,6.4H334.4l11.962,27.531Z"
                              class="cls-3" transform="translate(186.033 5.302)"/>
                        <path d="M403.4,61.652H276v-.19l11.772-27.531L276,6.4H403.4l11.962,27.531Z"
                              class="cls-4" transform="translate(248.044 5.302)"/>
                        <path d="M472.6,61.652H345.2v-.19l11.772-27.531L345.2,6.4H472.6l11.772,27.531Z"
                              class="cls-5" transform="translate(310.235 5.302)"/>
                        <path d="M541.5,61.652H414.1v-.19l11.772-27.531L414.1,6.4H541.5l11.772,27.531Z"
                              class="cls-6" transform="translate(372.156 5.302)"/>
                        <path d="M290.579,80.626H127.1L144,40.563,127.1.69V.5H290.579l17.278,40.063Z"
                              class="cls-7" transform="translate(114.226)"/>
                        <path d="M290.579,80.626H127.1L144,40.563,127.1.69V.5H290.579l17.278,40.063Z"
                              class="cls-8" transform="translate(114.226)"/>
                        <text id="F" class="cls-10" transform="translate(68.249 44.765)">
                            <tspan x="0" y="0">F</tspan>
                        </text>
                        <text id="E" class="cls-10" transform="translate(197.438 44.765)">
                            <tspan x="0" y="0">E</tspan>
                        </text>
                        <text id="D" class="cls-11" transform="translate(320.192 51.186)">
                            <tspan x="0" y="0">D</tspan>
                        </text>
                        <text id="C" class="cls-12" transform="translate(457.725 44.765)">
                            <tspan x="0" y="0">C</tspan>
                        </text>
                        <text id="B" class="cls-15" transform="translate(589.849 44.765)">
                            <tspan x="0" y="0">B</tspan>
                        </text>
                        <text id="A" class="cls-13" transform="translate(721.172 44.765)">
                            <tspan x="0" y="0">A</tspan>
                        </text>
                        <text id="A_" class="cls-13" transform="translate(847.265 44.765)">
                            <tspan x="0" y="0">A+</tspan>
                        </text>
                        <text id="_..." class="cls-9" transform="translate(5.847 101.462)">
                            <tspan x="0" y="0">...</tspan>
                        </text>
                        <text id="_500" class="cls-9" transform="translate(115 101.049)">
                            <tspan x="0" y="0">500</tspan>
                        </text>
                        <text id="_400" class="cls-9" transform="translate(240 101.462)">
                            <tspan x="0" y="0">400</tspan>
                        </text>
                        <text id="_300" class="cls-9" transform="translate(380 101.462)">
                            <tspan x="0" y="0">300</tspan>
                        </text>
                        <text id="_200" class="cls-9" transform="translate(508 101.462)">
                            <tspan x="0" y="0">200</tspan>
                        </text>
                        <text id="_100" class="cls-9" transform="translate(643 101.462)">
                            <tspan x="0" y="0">100</tspan>
                        </text>
                        <text id="_0" class="cls-9" transform="translate(778 102.462)">
                            <tspan x="0" y="0">0</tspan>
                        </text>
                        <text id="_-100" class="cls-9" transform="translate(898 101.462)">
                            <tspan x="0" y="0">-100</tspan>
                        </text>
                    </g>
                    <g transform="translate(11 472)">
                        <g transform="translate(300 66.413)">
                            <path class="cls-16" d="M.4.2,13.174,25.965,25.948.2" transform="translate(-0.4 -0.2)"/>
                            <path class="cls-17" d="M.4.2,13.174,25.965,25.948.2" transform="translate(-0.4 -0.2)"/>
                        </g>
                    </g>
                    <text class="cls-18" transform="translate(95 502)">
                        <tspan x="5.789" y="15">Gemiddeld energielabel van woningen in Vlaanderen</tspan>
                        <tspan class="cls-19" y="15"> ~ 390 kWh/(m² jaar)</tspan>
                    </text>
                    <circle style="fill:rgb(220,220,220); stroke:none;" r="2" cx="705" cy="656" />
                    <line x1="705" x2="705" y1="655" y2="670" style="fill:none; stroke:rgb(220,220,220);" />
                    <circle style="fill:rgb(220,220,220); stroke:none;" r="2" cx="705" cy="670" />
                    <text class="cls-18" transform="translate(620 670)">
                        <tspan x="5.789" y="15">Vlaamse doelstelling 2050</tspan>
                        <tspan class="cls-19" x="25" y="35">100 kWh/(m² jaar)</tspan>
                    </text>
                </g>
            </svg>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'introductie',
        data: function () {
            return {}
        }
    }
</script>